import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const CityContext = createContext();

const STORAGE_KEY = 'anadolu-selected-city';

export const CityProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedCity, setSelectedCityState] = useState(() => localStorage.getItem(STORAGE_KEY) || '');

  // Üye giriş yaptığında ve kullanıcı henüz manuel bir şehir seçmediyse, kayıtlı şehri varsayılan yap
  useEffect(() => {
    if (user?.city && !localStorage.getItem(STORAGE_KEY)) {
      setSelectedCityState(user.city);
    }
  }, [user]);

  const setSelectedCity = (cityName) => {
    setSelectedCityState(cityName);
    if (cityName) {
      localStorage.setItem(STORAGE_KEY, cityName);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <CityContext.Provider value={{ selectedCity, setSelectedCity }}>
      {children}
    </CityContext.Provider>
  );
};

export const useCity = () => {
  const context = useContext(CityContext);
  if (!context) {
    throw new Error('useCity hook CityProvider içinde kullanılmalıdır');
  }
  return context;
};

export default CityContext;
